import { apiFetch } from './apiClient';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://103.57.220.186/api/v1';
export const BACKEND_ORIGIN = API_BASE_URL.replace(/\/api\/v\d+$/, '');

export function getFullImageUrl(path: string): string {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('data:')) return path;
  if (path.startsWith('images/')) return `/${path}`;
  const safePath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_ORIGIN}${safePath}`;
}


interface PaymentQrResponse {
  imageUrl: string | null;
}

export async function getPaymentQr(): Promise<string | null> {
  const res = await apiFetch<PaymentQrResponse>('/settings/payment-qr', { skipAuth: true });
  return res.imageUrl;
}

export async function uploadPaymentQr(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await apiFetch<{ imageUrl: string }>('/settings/payment-qr', {
    method: 'PUT',
    body: formData,
  });
  return res.imageUrl;
}

export async function deletePaymentQr(): Promise<void> {
  await apiFetch('/settings/payment-qr', { method: 'DELETE' });
}

interface BannersResponse {
  banners: string[];
}

export async function getBanners(): Promise<string[]> {
  const res = await apiFetch<BannersResponse>('/settings/banners', { skipAuth: true });
  return res.banners;
}

export async function updateBanners(formData: FormData): Promise<string[]> {
  const res = await apiFetch<BannersResponse>('/settings/banners', {
    method: 'PUT',
    body: formData,
  });
  return res.banners;
}

export interface FixedSlot {
  id: string;
  name: string;
  startTime: string;
  endTime: string;
  order: number;
}

interface FixedSlotsResponse {
  slots: FixedSlot[];
}

export async function getFixedSlots(): Promise<FixedSlot[]> {
  const res = await apiFetch<FixedSlotsResponse>('/settings/slots', { skipAuth: true });
  return res.slots;
}

export async function updateFixedSlots(slots: FixedSlot[]): Promise<FixedSlot[]> {
  const res = await apiFetch<FixedSlotsResponse>('/settings/slots', {
    method: 'PUT',
    body: { slots },
  });
  return res.slots;
}

export interface GalleryImage {
  id: string;
  url: string;
  uploadedAt: string;
}

export interface GalleryAlbum {
  id: string;
  title: string;
  description?: string;
  cover: string;
  images: GalleryImage[];
  showOnHome?: boolean;
}

interface GalleryResponse {
  albums: GalleryAlbum[];
}

export async function getGallery(): Promise<GalleryAlbum[]> {
  const res = await apiFetch<GalleryResponse>('/settings/gallery', { skipAuth: true });
  return res.albums;
}

export async function updateGallery(albums: GalleryAlbum[]): Promise<GalleryAlbum[]> {
  const res = await apiFetch<GalleryResponse>('/settings/gallery', {
    method: 'PUT',
    body: { albums },
  });
  return res.albums;
}


export async function uploadGalleryImages(files: File[]): Promise<string[]> {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }
  const res = await apiFetch<{ urls: string[] }>('/settings/gallery/upload', {
    method: 'POST',
    body: formData,
  });
  return res.urls;
}

export async function deleteGalleryFile(imageUrl: string): Promise<void> {
  await apiFetch('/settings/gallery/delete-file', {
    method: 'POST',
    body: { imageUrl },
  });
}




